import { toast } from "react-toastify";
import axiosinstances, { baseURL } from "../Helper/useAxios";

import { buildInterleavedString } from "../utils/Constant";
import { removeUserSession } from "../utils/comman/Common";
import { useSelector } from "react-redux";

async function forgotPasswordService(creds) {
  const logOut = () => {
    removeUserSession();
    window.location.href = "/";
  };

  const {
    userId,
    oldPassword,
    newPassword,
    reEnterNewPassword,
    headers,
    userIp,
  } = creds;

  const systemSalt = process.env.REACT_APP_SALT;

  const handleSubmit = async () => {
    // e.preventDefault();

    if (newPassword !== reEnterNewPassword) {
      toast.error(
        "The new passwords you entered do not match. Please try again."
      );
      console.log(
        "Error: New password and confirmation password do not match."
      );
      return;
    }

    if (oldPassword === newPassword) {
      toast.error("Old and new password cannot be the same.");
      console.log("Old and new password cannot be the same.");
      return;
    }

    const [axiosInstance] = axiosinstances(userIp);

    const encodedString = buildInterleavedString(
      oldPassword,
      newPassword,
      systemSalt
    );

    const url = `api/v1/upi/merchant/user/update/password?username=${userId}&encodedText=${encodedString}`;
    return axiosInstance
      .post(`${url}`, {}, { headers })
      .then((response) => {
        console.log("response", response);
        if (response?.status == 200) {
          if (response.data == "SUCCESS - Password updated") {
            toast.success(response.data);
            setTimeout(() => logOut(), 1500);
          } else {
            toast.warn(response.data);
          }

          console.log("updated password", response);
          return response;
        }
      })
      .catch((err) => {
        toast.warn(err);
        console.log(err);
      });
  };
  return handleSubmit();
}

export default forgotPasswordService;
